import './Header.css';

const Header = () => {
	const navRoutes = [
		{ name: 'Cotizar', route: process.env.REACT_APP_ENVIROMENT === 'prod' ? 'https://ecommerce.atmseguros.com.ar/' : 'https://ecommerce-dev.atmseguros.com.ar/' },
		{ name: 'Contacto', route: 'https://atmseguros.com.ar/contacto/' },
	]

	// TODO: menu hamburgesa para los links de contacto
	return (
		<div className='w-full flex flex-col'>
 			<div className='hidden md:flex w-full m-auto h-auto py-4 bg-light-red'>
				<div className="md:w-[85%] m-auto flex flex-row justify-between">
					<div className='flex-row gap-3 flex text-white text-sm font-light'>
						<p>Atención Asegurados</p>
						<a href="tel:0810-345-0492">0810-345-0492</a>
						|
						<p>Cotizaciones</p>
						<a href="tel:0810-345-0491">0810 345 0491</a>
					</div>
					<div className='flex-row gap-3 flex text-white text-sm font-light'>
						<p>Portales:</p>
						<a href="https://tupoliza.atmseguros.com.ar/">Asegurados |</a>
						<a href="https://extranet.atmseguros.com.ar/">Productores |</a>
						<a href="https://proveedores.atmseguros.com.ar/">Proveedores</a>
					</div>
				</div>
			</div>
			<div className="w-full m-auto h-auto py-6 bg-white flex text-black">
				<div className="w-4/5 m-auto flex flex-row justify-between items-center">
					<a href="/"><img src={require('../../assets/img/ATM_LOGO.png')} alt="" srcSet="" /></a>
					<div className='flex-row flex text-md font-light items-center justify-between divide-x-[1px]'>
						{navRoutes.map(item => 
							<a className='py-1 px-4 no-underline text-black' key={item.name} href={item.route}>
								{item.name}
							</a>)}
					</div>
				</div>
			</div>
 		</div>
	);
};


export default Header;